import { beADate, getEpoch } from '../fns.js';

var addMethods = function addMethods(SpaceTime) {
  var methods = {
    isAfter: function isAfter(d) {
      d = beADate(d, this);
      var epoch = getEpoch(d);

      if (epoch === null) {
        return null;
      }

      return this.epoch > epoch;
    },
    isBefore: function isBefore(d) {
      d = beADate(d, this);
      var epoch = getEpoch(d);

      if (epoch === null) {
        return null;
      }

      return this.epoch < epoch;
    },
    isEqual: function isEqual(d) {
      d = beADate(d, this);
      var epoch = getEpoch(d);

      if (epoch === null) {
        return null;
      }

      return this.epoch === epoch;
    },
    isBetween: function isBetween(start, end) {
      var isInclusive = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      start = beADate(start, this);
      end = beADate(end, this);
      var startEpoch = getEpoch(start);

      if (startEpoch === null) {
        return null;
      }

      var endEpoch = getEpoch(end);

      if (endEpoch === null) {
        return null;
      }

      if (isInclusive) {
        return this.isBetween(start, end) || this.isEqual(start) || this.isEqual(end);
      }

      return startEpoch < this.epoch && this.epoch < endEpoch;
    }
  }; //hook them into proto

  Object.keys(methods).forEach(function (k) {
    SpaceTime.prototype[k] = methods[k];
  });
};

export default addMethods;